/**
 * @fileoverview Saved Restaurants page route configuration
 * Displays user's saved/favorited restaurants with search and filtering
 */

// Library imports
import { createFileRoute } from "@tanstack/react-router";

// Components
import { SavedRestaurantsPage } from "@/features/dashboard/pages/restaurants";

/**
 * Route configuration for the saved restaurants page
 */
export const Route = createFileRoute("/(app)/dashboard/restaurants")({
  component: SavedRestaurantsPage,
  // Add error boundary handling
  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-[400px] items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="font-display text-2xl text-brand">Failed to load restaurants</h1>
        <pre className="mt-4 text-sm text-muted-foreground">{error.message}</pre>
      </div>
    </div>
  ),
});